"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalance = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const roundMoney_1 = require("../../../../utils/roundMoney");
const AdminPaymentInfoBlock_1 = require("../InfoBlock/AdminPaymentInfoBlock");
const messages_1 = require("../messages");
const AccountBalance = (props) => {
    const { value } = props;
    const { formatMessage, locale } = (0, react_intl_1.useIntl)();
    const debitTitle = (0, react_1.useMemo)(() => formatMessage(messages_1.messages.debitTitle), [formatMessage]);
    // Full implementation after go live https://mywork.xiag.ch/search#88640
    if (true)
        return null;
    return (react_1.default.createElement(AdminPaymentInfoBlock_1.AdminPaymentInfoBlock, { className: `${__1.className}__debit`, title: debitTitle }, (0, roundMoney_1.localizeMoney)(value, locale, 'Reservation/AdminPayment/components/AccountBalance')));
};
exports.AccountBalance = AccountBalance;
//# sourceMappingURL=AccountBalance.js.map